module.exports = __webpack_public_path__ + "static/media/traptris-cover.36f9b899.png";